import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import { SxProps, Theme } from '@mui/system';

import { useStore } from 'src/context/StoreContext';

type InputSearchProps = {
  labelInput?: string;
  name: string;
  value: string;
  readonly?: boolean;
  sx?: SxProps<Theme>;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
};

const InputSearch: React.FC<InputSearchProps> = (props) => {
  const storeContext = useStore();
  const store = storeContext.store;

  const handleClickSearch = () => {
    console.log('search');
  };

  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <Box>
      <OutlinedInput
        fullWidth
        type='text'
        placeholder={props.labelInput}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        readOnly={props.readonly}
        startAdornment={
          <InputAdornment position='start'>
            <IconButton
              aria-label='search'
              onClick={handleClickSearch}
              onMouseDown={handleMouseDown}
              edge='start'
              sx={{ width: '24px', height: '24px', ml: '-4px' }}
            >
              <Box
                component={'img'}
                src='/images/ic-search.svg'
                alt='icon search'
              />
            </IconButton>
          </InputAdornment>
        }
        sx={{
          width: '160px',
          height: '48px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: props.error ? '#d32f2f !important' : '#BDBDBD',
          },
          '& .MuiInputBase-input': { p: '12px 16px 12px 0px' },
          '& input::placeholder': {
            fontSize: '12px',
            fontWeight: 400,
            color: '#AAB2BD',
            opacity: 1,
          },
          backgroundColor: store.palette.input.bgColor,
          ...props.sx,
        }}
        inputProps={{
          sx: {
            fontSize: '12px',
            fontWeight: 400,
            color: store.palette.input.color,
            backgroundColor: store.palette.input.bgColor,
          },
        }}
      />
    </Box>
  );
};

export default InputSearch;
